import Heading from "./Heading";

export { capitalizedHeading } from "./Heading.styles";
export default Heading;
